import { render, staticRenderFns } from "./DashboardStudent.vue?vue&type=template&id=878a8942&scoped=true"
import script from "./DashboardStudent.vue?vue&type=script&lang=js"
export * from "./DashboardStudent.vue?vue&type=script&lang=js"
import style0 from "./DashboardStudent.vue?vue&type=style&index=0&id=878a8942&prod&lang=sass&scoped=true"
import style1 from "./DashboardStudent.vue?vue&type=style&index=1&id=878a8942&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "878a8942",
  null
  
)

export default component.exports